module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-700-latin-ext7.c1506c7.woff2";